import { Component, ComponentDefinition, ParentComponent } from "components/components/Component";
import { isPostRenderedComponent } from "components/components/Component";
import { listenDataUpdateRequest } from "components/components/componentUpdateRequestedUtil";
import { ValueBaseComponent } from "components/components/ValueBaseComponent";
import $ from "jquery";
import template from "./block.hbs";
import "./block.scss";

export class Block extends ValueBaseComponent<BlockDefinition> implements ParentComponent {

    public readonly componentType: string = "block";
    public children: Component[] = [];

    constructor(schema: BlockDefinition) {
        super(schema);
        this.definition.style = this.definition.style ?? "h1";
    }

    public render(): Element {
        this.view = $(template(this.definition))[0];
        listenDataUpdateRequest(this);
        return this.view;
    }

    public appendChildView(childView: Node): void {
        $(childView).appendTo($(this.view).find(".c-block__children:first") as JQuery<HTMLElement>);
    }

    public postRender() {
        for (let child of this.children) {
            if (isPostRenderedComponent(child)) {
                child.postRender();
            }
        }
    }
}

export interface BlockDefinition extends ComponentDefinition {
    titleKey?: string;
    mdwidth?: number;
    lgwidth?: number;
    smwidth?: number;
    style: "h1" | "h2" | "h3" | "danger" | "warning" | "info" | "success";
}
